// Generate email-safe HTML from template structure
export const generateEmailHtml = (sections, globalStyles) => {
  const sectionHtml = sections
    .map((section) => {
      const blocksHtml = section.blocks.map((block) => generateBlockHtml(block)).join("");
      return `
        <tr>
          <td style="background-color: ${section.backgroundColor || "#ffffff"}; padding: ${section.padding || "20px"};">
            ${blocksHtml || "&nbsp;"}
          </td>
        </tr>
      `;
    })
    .join("");

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>Email</title>
  <!--[if mso]>
  <noscript>
    <xml>
      <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  </noscript>
  <![endif]-->
  <style>
    body { margin: 0; padding: 0; width: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    img { border: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; max-width: 100%; }
    a { text-decoration: none; }
    @media only screen and (max-width: 600px) {
      .email-container { width: 100% !important; }
      .stack-column { display: block !important; width: 100% !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: ${globalStyles.backgroundColor}; font-family: ${globalStyles.fontFamily};">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color: ${globalStyles.backgroundColor};">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table role="presentation" class="email-container" width="${parseInt(globalStyles.contentWidth)}" cellspacing="0" cellpadding="0" border="0" style="background-color: ${globalStyles.contentBackgroundColor}; max-width: ${globalStyles.contentWidth};">
          ${sectionHtml}
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};

const generateBlockHtml = (block) => {
  switch (block.type) {
    case "text":
      return generateTextHtml(block);
    case "image":
      return generateImageHtml(block);
    case "button":
      return generateButtonHtml(block);
    case "divider":
      return generateDividerHtml(block);
    case "spacer":
      return generateSpacerHtml(block);
    case "social":
      return generateSocialHtml(block);
    case "columns":
      return generateColumnsHtml(block);
    case "list":
      return generateListHtml(block);
    case "html":
      return block.html || "";
    default:
      return "";
  }
};

const generateTextHtml = (block) => {
  const style = `
    font-size: ${block.fontSize || "16px"};
    color: ${block.textColor || "#1f2937"};
    text-align: ${block.textAlign || "left"};
    line-height: ${block.lineHeight || "1.6"};
    font-weight: ${block.fontWeight || "normal"};
    padding: ${block.padding || "0"};
    margin: 0;
  `.replace(/\s+/g, " ");

  return `<p style="${style}">${block.content || ""}</p>`;
};

const generateImageHtml = (block) => {
  if (!block.src) return "";
  
  const imgStyle = `
    max-width: ${block.width || "100%"};
    height: auto;
    border-radius: ${block.borderRadius || "0"};
    display: block;
  `.replace(/\s+/g, " ");

  const containerStyle = `
    text-align: ${block.alignment || "center"};
    padding: ${block.padding || "0"};
  `.replace(/\s+/g, " ");

  return `
    <div style="${containerStyle}">
      <img src="${block.src}" alt="${block.alt || ""}" style="${imgStyle}" />
    </div>
  `;
};

const generateButtonHtml = (block) => {
  const buttonStyle = `
    display: inline-block;
    background-color: ${block.backgroundColor || "#1CBCF8"};
    color: ${block.textColor || "#ffffff"};
    padding: ${block.buttonPadding || "12px 24px"};
    border-radius: ${block.borderRadius || "6px"};
    text-decoration: none;
    font-weight: ${block.fontWeight || "600"};
    font-size: ${block.fontSize || "14px"};
  `.replace(/\s+/g, " ");

  const containerStyle = `
    text-align: ${block.alignment || "center"};
    padding: ${block.padding || "10px 0"};
  `.replace(/\s+/g, " ");

  return `
    <div style="${containerStyle}">
      <!--[if mso]>
      <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${block.href || "#"}" style="height:40px;v-text-anchor:middle;width:200px;" arcsize="10%" strokecolor="${block.backgroundColor || "#1CBCF8"}" fillcolor="${block.backgroundColor || "#1CBCF8"}">
        <w:anchorlock/>
        <center style="color:${block.textColor || "#ffffff"};font-family:sans-serif;font-size:${block.fontSize || "14px"};font-weight:bold;">${block.text || "Click Here"}</center>
      </v:roundrect>
      <![endif]-->
      <!--[if !mso]><!-->
      <a href="${block.href || "#"}" style="${buttonStyle}">${block.text || "Click Here"}</a>
      <!--<![endif]-->
    </div>
  `;
};

const generateDividerHtml = (block) => {
  const hrStyle = `
    border: none;
    border-top: ${block.thickness || "1px"} ${block.style || "solid"} ${block.color || "#e5e7eb"};
    margin: 0;
  `.replace(/\s+/g, " ");

  return `
    <div style="padding: ${block.padding || "10px 0"};">
      <hr style="${hrStyle}" />
    </div>
  `;
};

const generateSpacerHtml = (block) => {
  return `<div style="height: ${block.height || "20px"};"></div>`;
};

const generateSocialHtml = (block) => {
  const socials = block.socials || [];
  const iconSize = parseInt(block.iconSize || "32");
  
  const socialIcons = {
    facebook: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
    twitter: "https://cdn-icons-png.flaticon.com/512/733/733579.png",
    linkedin: "https://cdn-icons-png.flaticon.com/512/733/733561.png",
    instagram: "https://cdn-icons-png.flaticon.com/512/733/733558.png",
    youtube: "https://cdn-icons-png.flaticon.com/512/733/733646.png",
    website: "https://cdn-icons-png.flaticon.com/512/1006/1006771.png",
  };

  const iconsHtml = socials
    .map((social) => {
      const iconUrl = socialIcons[social.type] || socialIcons.website;
      const linkStyle = `
        display: inline-block;
        width: ${iconSize}px;
        height: ${iconSize}px;
        margin: 0 ${parseInt(block.spacing || "12") / 2}px;
        border-radius: ${block.iconStyle === "circle" ? "50%" : "4px"};
        background-color: ${block.iconBackground || "#1CBCF8"};
        text-align: center;
        line-height: ${iconSize}px;
      `.replace(/\s+/g, " ");
      
      return `
        <a href="${social.url || "#"}" style="${linkStyle}">
          <img src="${iconUrl}" width="${iconSize * 0.5}" height="${iconSize * 0.5}" alt="${social.type}" style="vertical-align: middle; filter: brightness(0) invert(1);" />
        </a>
      `;
    })
    .join("");

  return `
    <div style="text-align: ${block.alignment || "center"}; padding: ${block.padding || "10px 0"};">
      ${iconsHtml}
    </div>
  `;
};

const generateColumnsHtml = (block) => {
  const columnCount = block.columns || 2;
  const columnContent = block.columnContent || Array(columnCount).fill({ content: "" });
  const columnWidth = Math.floor(100 / columnCount);

  const columnsHtml = Array(columnCount)
    .fill(0)
    .map((_, index) => {
      return `
        <td class="stack-column" width="${columnWidth}%" style="padding: 10px; vertical-align: top;">
          ${columnContent[index]?.content || `Column ${index + 1}`}
        </td>
      `;
    })
    .join("");

  return `
    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="padding: ${block.padding || "0"};">
      <tr>
        ${columnsHtml}
      </tr>
    </table>
  `;
};

const generateListHtml = (block) => {
  const items = block.items || [];
  const tag = block.listType === "numbered" ? "ol" : "ul";
  
  const listStyle = `
    margin: 0;
    padding: ${block.padding || "0 0 0 20px"};
    color: ${block.textColor || "#1f2937"};
    font-size: ${block.fontSize || "16px"};
    line-height: ${block.lineHeight || "1.8"};
  `.replace(/\s+/g, " ");

  const itemsHtml = items.map((item) => `<li>${item}</li>`).join("");

  return `<${tag} style="${listStyle}">${itemsHtml}</${tag}>`;
};
